import { del, get, getByID, post, postFormData, put, putFile, urlApiTegra } from "../../../service/api";

const url = urlApiTegra;

const postProjects = async (dadosBody: object, token: string) => {
  return postFormData(`${url}/projects`, dadosBody, token);
};

const getProjects = async (token: string) => {
  return get(`${url}/projects`, token);
};

const getCreateProjects = (token: string) => {
  return get(`${url}/projects/create`, token);
};

const getByIdProjects = async (id: string, token: string) => {
  return getByID(`${url}/projects/${id}`, token);
};

const getRoles = async (token: string) => {
  return get(`${url}/roles`, token);
};

const putProjects = async (dadosBody: any, id: string, token: string) => {
  return putFile(`${url}/projects/${id}`, dadosBody, token);
};

const delProjects = async (id: string, token: string) => {
  return del(`${url}/projects/${id}`, token);
};

const delImageProjects = async (token: string, id: string) => {
  return del(`${url}/projects/image/${id}`, token);
};

const uploadCsvAndXlsx = async ({ file, token, path }: { file: any; token: string; path: string }) => {
  return postFormData(`${url}/upload-sheet/project-${path}`, { file }, token);
};

export const service = {
  postProjects,
  getProjects,
  getCreateProjects,
  putProjects,
  delProjects,
  delImageProjects,
  getRoles,
  getByIdProjects,
  uploadCsvAndXlsx,
};
